/**
 * 会员卡：头像下方整行展示
 *  - 会员：有效期至 X · 还剩 N 天 + 续费
 *  - 非会员：开通 VIP 解锁权益 + 开通
 */

import React from 'react';
import { useHistory } from 'react-router-dom';
import { RightArrow } from 'component/Icon/Arrow';
import { statistic, StatisticCategory, isWechatMiniProgram, openH5InNewWebview } from 'util/index';
import styles from './MemberCard.module.scss';

interface Props {
    isVip: boolean;
    expireTime?: string;
    isLifetime?: boolean;
}

// 计算到期剩余天数（expireTime 形如 YYYY-MM-DD）
function daysLeft(expireTime?: string): number | null {
    if (!expireTime) return null;
    const t = new Date(`${expireTime}T23:59:59`).getTime();
    if (isNaN(t)) return null;
    return Math.max(0, Math.ceil((t - Date.now()) / 86400000));
}

export function MemberCard(props: Props) {
    const history = useHistory();
    function gotoPay() {
        if (isWechatMiniProgram()) {
            openH5InNewWebview({ url: '/mp/user/pay', jumpMethod: 'navigateTo' });
        } else {
            history.push('/mp/user/pay');
        }
        statistic({ category: StatisticCategory.UserCenter, action: '点击-会员卡' });
    }

    if (props.isVip) {
        const left = props.isLifetime ? null : daysLeft(props.expireTime);
        return (
            <div
                className={`${styles.card} ${styles.cardVip}`}
                onClick={props.isLifetime ? undefined : gotoPay}
            >
                <div className={styles.info}>
                    <div className={styles.title}>
                        {props.isLifetime ? '终身会员' : (props.expireTime || '会员已开通')}
                    </div>
                    <div className={styles.sub}>
                        {props.isLifetime
                            ? '永久有效 · 错题自动整理 / 家长学情报告'
                            : (left !== null ? `还剩 ${left} 天 · 错题自动整理 / 家长学情报告` : '错题自动整理 / 家长学情报告')}
                    </div>
                </div>
                <span className={styles.btn}>{props.isLifetime ? '已开通' : '续费'}</span>
            </div>
        );
    }

    return (
        <div className={`${styles.card} ${styles.cardPromote}`} onClick={gotoPay}>
            <div className={styles.info}>
                <div className={styles.title}>开通 VIP 解锁全部权益</div>
                <div className={styles.sub}>错题自动整理 · 家长学情报告 · 全技能畅练</div>
            </div>
            <span className={styles.btn}>开通 <RightArrow style={{ fontSize: '14px' }} /></span>
        </div>
    );
}
